
import React from 'react';

const CompanySettings = () => {
  return (
    <div className="space-y-6">
      <div className="p-6 rounded-lg bg-gradient-to-r from-violet-50/80 to-fuchsia-50/80 border border-purple-100">
        <h2 className="text-xl font-semibold mb-6 text-purple-900">Company Information</h2>
        <p className="text-gray-600">Company settings form will be implemented here.</p>
      </div>
    </div>
  );
};

export default CompanySettings;
